import { render, staticRenderFns } from "./forgot-username.vue?vue&type=template&id=a1f5073a&scoped=true&"
import script from "./forgot-username.vue?vue&type=script&lang=js&"
export * from "./forgot-username.vue?vue&type=script&lang=js&"
import style0 from "@/assets/auth-screen.scss?vue&type=style&index=0&id=a1f5073a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f5073a",
  null
  
)

component.options.__file = "forgot-username.vue"
export default component.exports